<template>
  <v-row no-gutters>
    <!-- computer UI -->
    <v-col cols="12" md="12" v-if="showComputer">
      <v-row no-gutters>
        <v-col cols="3" md="3">
          <v-sheet class="pageheight" v-if="showPageCustomer">
            <pageCustomer @pageMethod="pageMethod" v-if="keyId==0"/>
            <friends @friendMethod="friendMethod" v-else/>
            <v-col cols="12" md="3" class="app-fab--absolute mb-2" v-if="customerOrPage=='C'">
              <v-row no-gutters class="black pa-2">
                <v-col cols="12" md="12">
                  <v-tabs v-model="keyId" align-tabs="center"
                  color="primary" grow>
                    <v-tab style="text-transform: none"
                      >Pages</v-tab
                    >
                    <v-tab style="text-transform: none"
                      >Friends</v-tab
                    >
                  </v-tabs>
                  
                </v-col>
              </v-row>
            </v-col>
          </v-sheet>
          <v-sheet class="information-window-v-sheet" v-else>
            <page-customer-list
              :tempPage="tempPage"
              @closeDialog="closePageCustomerList"
              @customerMethod="customerMethod"
            />
          </v-sheet>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="6" md="6">
          <v-sheet v-if="keyId==0">
            <chatting :pageId="pageId" v-if="showChattingComputer == 1" />
            <chatting-customer
              :pageId="custPageId"
              :refreshChatting="refreshChatting"
              :customerId="customerId"
              v-else-if="showChattingComputer == 2"
            />
          </v-sheet>
          <v-sheet v-else>
            <chatting-friend
              :refreshFriend="refreshFriend"
            />
          </v-sheet>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="3" md="3">
          <v-sheet class="information-window-v-sheet" v-if="keyId==0">
            <user-detail
              :customerId="customerId"
              v-if="showChattingComputer == 2"
            />
          </v-sheet>
          <v-sheet class="information-window-v-sheet" v-else>
            <user-detail
              :customerId="friendId"
            />
          </v-sheet>
        </v-col>
      </v-row>
    </v-col>
    <!-- phone UI -->
    <v-col cols="12" md="12" v-else>
      <v-row no-gutters>
        <v-col cols="12" md="12">
          <v-sheet class="pageheight" v-if="showPageCustomer">
            <pageCustomer @pageMethod="pageMethod"  v-if="keyId==0"/>
            <friends @friendMethod="friendMethod" :friendListIndex="friendListIndex" v-else/>
            <v-col cols="12" md="3" class="app-fab--absolute mb-2" v-if="customerOrPage=='C'">
              <v-row no-gutters class="black pa-2">
                <v-col cols="12" md="12">
                  <v-tabs v-model="keyId" align-tabs="center"
                  color="primary" grow>
                    <v-tab  style="text-transform: none"
                      >Pages</v-tab
                    >
                    <v-tab  style="text-transform: none"
                      >Friends</v-tab
                    >
                  </v-tabs>
                </v-col>
              </v-row>
            </v-col>
          </v-sheet>
          <v-sheet class="information-window-v-sheet" v-else>
            <page-customer-list
              :tempPage="tempPage"
              @closeDialog="closePageCustomerList"
              @customerMethod="customerMethod"
            />
          </v-sheet>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="12">
      <v-bottom-sheet v-model="dialogChatting" fullscreen>
        <v-sheet>
          <dialogChatting
            @closeDialog="dialogChatting = false"
            :pageId="chattingPageId"
            :title="title"
            :showChattingMobile="showChattingMobile"
            :refreshChatting="refreshChatting"
            :customerId="customerId"
            :keyId="keyId"
            @friendListMethodIndex="friendListMethodIndex"
          />
        </v-sheet>
      </v-bottom-sheet>
    </v-col>
  </v-row>
</template>
  <script>
import chatting from "@/components/Chatting.vue";
import pageCustomer from "@/components/PageCustomer.vue";
import dialogChatting from "@/components/DialogChatting.vue";
import PageCustomerList from "@/components/PageCustomerList.vue";
import ChattingCustomer from "@/components/ChattingCustomer.vue";
import UserDetail from "@/components/UserDetail.vue";
import Friends from '@/components/Friends.vue';
import ChattingFriend from '@/components/ChattingFriend.vue';
import friService from "../service/FriendService";
import pgService from "../service/PageService";
export default {
  data: () => ({
    pageId: 0,
    dialogChatting: false,
    chattingPageId: 0,
    title: "",
    tempPage: {},
    showPageCustomer: true,
    refreshChatting: 0,
    refreshFriend:0,
    customerId: 0,
    custPageId: 0,
    showChattingComputer: 0,
    showChattingMobile: 0,
    customerOrPage: "",
    keyId:0,
    friendId:0,
    friendListIndex:0,
  }),
  props: {},
  mounted: function () {
    this.loginUser = this.$store.state.userAccountChat;
    this.customerOrPage = this.$store.state.customerOrPage;
  },
  methods: {
    friendListMethodIndex:function(){
      this.friendListIndex = Number(this.friendListIndex)+1;
    },
    closePageCustomerList: function () {
      this.showPageCustomer = true;
      this.showChattingComputer = 0;
    },
    customerMethod: function (item) {

      if(item.look>0){
        pgService
        .updateMessageLook(this.tempPage.pageId,this.customerOrPage,item.participantDto.userAccountId)
        .then((response) => {
          item.look = 0;
        })
        .catch((error) => {
          //this.$swal("Fail!", error.response.data.message, "error");
        });
      }

      if (this.showComputer) {
        this.showChattingComputer = 2;
        this.custPageId = this.tempPage.pageId;
      } else {
        //if (index != 0) {
        this.chattingPageId = this.tempPage.pageId;
        this.dialogChatting = true;
        this.showChattingMobile = 2;
        //}
        this.title = item.participantDto.profileName;
      }
      this.refreshChatting = Number(this.refreshChatting) + 1;
      this.customerId = item.participantDto.userAccountId;



    },
    pageMethod: function (item, index) {
      this.$store.commit("updatePage", item);
      if (this.customerOrPage != "C") {
        if (index != 0) {
          this.showPageCustomer = !this.showPageCustomer;
        }
        this.tempPage = Object.assign({}, item);
      } else {//P
        if(item.look>0){
        pgService
        .updateMessageLook(item.pageId,this.customerOrPage,this.loginUser.userId)
        .then((response) => {
          item.look = 0;
        })
        .catch((error) => {
          //this.$swal("Fail!", error.response.data.message, "error");
        });
      }
        //customer
        if (this.showComputer) {
          this.showChattingComputer = 1;
          this.pageId = item.pageId;
          this.refreshChatting = Number(this.refreshChatting) + 1;
        } else {
          if (index != 0) {
            this.showChattingMobile = 1;
            this.dialogChatting = true;
          }
          this.chattingPageId = item.pageId;
          this.title = item.title;
        }
      }
    },
    friendMethod: function (item, index) {
      this.$store.commit("updateFriend", item);
      item.privateMessageId = -1;
      if(item.look>0){
        friService
                    .updateFriendLook(item)
                    .then((response) => {
                      item.look = 0;
                    })
                    .catch((error) => {
                    });
      }
      if (this.showComputer) {
        this.friendId = item.userAccountId;
        this.refreshFriend = Number(this.refreshFriend)+1;
      }else{
        this.dialogChatting = true;
        this.title = item.profileName;
      }
    }
  },
  watch: {},
  components: {
    chatting,
    pageCustomer,
    dialogChatting,
    PageCustomerList,
    ChattingCustomer,
    UserDetail,
    Friends,
    ChattingFriend,
  },
  computed: {
    showComputer() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        case "lg":
          return true;
        case "xl":
          return true;
      }
    },
  },
};
</script>
  <style scoped>
.information-window-v-sheet {
  height: 92vh !important;
  overflow-x: scroll;
}
.pageheight {
  height: 87vh !important;
  overflow-x: scroll;
}
.app-fab--absolute {
  position: fixed;
  bottom: -1.5rem;
}

@media (min-width: 1024px) {
  .app-fab--absolute {
    bottom: -1.5rem;
  }
}
</style>